import React from 'react'

const Label = ({children, className,p}) => {
    return children ? (
    p?<p className={`uppercase font-semibold tracking-[1px] text-[0.6875rem] mb-2 ${className ? className : ""}`}>{children}</p>:
    <h5 className={`uppercase font-semibold tracking-[1px] text-[0.6875rem] mb-2 ${className ? className : ""}`}>{children}</h5>
    )
    : ''
}

export default Label
